import React from "react";

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("AppErrorBoundary caught an error", error);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.assign("/dashboard");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_top_left,_rgba(255,255,255,0.95),_rgba(240,240,240,0.8))] px-6" data-testid="app-error-boundary-screen">
          <div className="panel-surface max-w-xl space-y-5 px-6 py-6">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-zinc-500">Workspace recovery</p>
              <h1 className="mt-2 text-3xl font-semibold text-zinc-900" data-testid="app-error-boundary-title">This page hit an unexpected error.</h1>
              <p className="mt-2 text-sm text-zinc-600" data-testid="app-error-boundary-description">Your session is still safe. Reload the app or jump back to the dashboard without losing your login.</p>
            </div>
            <div className="flex flex-wrap gap-3">
              <button className="rounded-2xl bg-zinc-900 px-5 py-3 text-sm font-semibold text-white" data-testid="app-error-boundary-reload" onClick={this.handleReload} type="button">Reload app</button>
              <button className="rounded-2xl border border-zinc-200 px-5 py-3 text-sm font-semibold text-zinc-700" data-testid="app-error-boundary-dashboard" onClick={this.handleGoHome} type="button">Go to dashboard</button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}